import orderDataDict from '../../../../utils/orderDataDict';

// 初始化变量
const { ADD } = orderDataDict.ORDER_STATUS;

const returnStr = (val) => {
    return val || val === 0 ? val + '' : '';
};

// 改变table属性及值
const showTransformName = (val = {}, dictData = {}) => {
    const { TPL_EXCUTE_STATUS } = dictData;
    val.excuteStatusName = TPL_EXCUTE_STATUS[val.excuteStatus];
    val.orderStatus = returnStr(val.orderStatus);
    val.putBmsStatus = returnStr(val.putBmsStatus);
    val.putTmsStatus = returnStr(val.putTmsStatus);
    return val;
};

// 隐藏按钮操作
const hiddenTableBtn = (val) => {
    val.hiddenEvent = [];
    const actionKey = hideActionFunc(val);
    for (const k of Object.keys(actionKey)) {
        if (actionKey[k]()) val.hiddenEvent.push(k);
    }
};

// 初始化判断值
const keyProps = (val) => {
    const excuteStatus = Number(val.excuteStatus);
    return {
        isAdd: excuteStatus === ADD
    };
};

// 隐藏操作 判断逻辑
export const hideActionFunc = (val) => {
    const { isAdd } = keyProps(val);
    return {
        edit() {
            const hideFlag = !isAdd;
            return hideFlag;
        }
    };
};

export const showTableListTransform = (tableList = [], dictData = {}) => {
    tableList.forEach((item, index) => {
        showTransformName(item, dictData);
        hiddenTableBtn(item);
    });
    return tableList;
};
